import http from "./http-common";

class WageService {
   
    async saveReferencePositions(positions) {
        const response = await http.post("/WorkOrganisation/UpdateJobPositions", JSON.stringify(positions));
        var data = response.data;
        return data;
    }

    async getReferencePositions() {
        const response = await http.get("/WorkOrganisation/GetJobPositions");
        var data = response.data;
        return data;
    }

    async addBaseFactor(factorNumber, name) {
        let formData = new FormData();
        formData.append('factorNumber', factorNumber);
        formData.append('name', name);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WageSetting/AddBaseFactor", formData, config);
        var data = response.data;
        return data;
    }

    async updateBaseFactor(baseFactorId, factorNumber, name) {
        let formData = new FormData();
        formData.append('baseFactorId', baseFactorId);
        formData.append('factorNumber', factorNumber);
        formData.append('name', name);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WageSetting/UpdateBaseFactor", formData, config);
        var data = response.data;
        return data;
    }

    async deleteBaseFactor(baseFactorId) {
        if (baseFactorId == null)
            baseFactorId = "";
        const response = await http.get("/WageSetting/DeleteBaseFactor?baseFactorId=" + baseFactorId);
        var data = response.data;
        return data;
    }

    async getWageFactorGrades(baseFactorId) {
        if (baseFactorId == null)
            baseFactorId = "";
        const response = await http.get("/WageSetting/GetBaseFactorGrades?baseFactorId=" + baseFactorId);
        var data = response.data;
        return data;
    }

    async getPositionBaseFactorGrades(jobPositionId) {
        if (jobPositionId == null)
            jobPositionId = "";
        const response = await http.get("/WageSetting/GetPositionBaseFactorGrades?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async getPositionBaseFactorGradesWithGrades(jobPositionId) {
        if (jobPositionId == null)
            jobPositionId = "";
        const response = await http.get("/WageSetting/getPositionBaseFactorGradesWithGrades?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async getPositionTotalBasePoints(jobPositionId) {
        if (jobPositionId == null)
            jobPositionId = "";
        const response = await http.get("/WageSetting/getPositionTotalBasePoints?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async getFactorAnalysis(jobPositionId, referencePosition) {
        if (jobPositionId == null)
            jobPositionId = "";
        if (referencePosition == null)
            referencePosition = "";
        const response = await http.get("/WageSetting/GetFactorAnalysis?jobPositionId=" + jobPositionId + "&referencePosition=" + referencePosition);
        var data = response.data;
        return data;
    }

    async addBaseFactorGrade(baseFactorId, gradeNumber, description, points) {
        let formData = new FormData();
        formData.append('baseFactorId', baseFactorId);
        formData.append('gradeNumber', gradeNumber);
        formData.append('description', description);
        formData.append('points', points);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WageSetting/AddBaseFactorGrade", formData, config);
        var data = response.data;
        return data;
    }

    async updateBlockGrade(blockGradeId, gradeNumber, from, to, points) {
        let formData = new FormData();
        formData.append('blockGradeId', blockGradeId);
        formData.append('gradeNumber', gradeNumber);
        formData.append('from', from);
        formData.append('to', to);
        formData.append('points', points);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WageSetting/UpdateBlockGrade", formData, config);
        var data = response.data;
        return data;
    }

    async updateBaseFactorGrade(baseFactorGradeId, gradeNumber, description, points) {
        let formData = new FormData();
        formData.append('baseFactorGradeId', baseFactorGradeId);
        formData.append('gradeNumber', gradeNumber);
        formData.append('description', description);
        formData.append('points', points);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WageSetting/UpdateBaseFactorGrade", formData, config);
        var data = response.data;
        return data;
    }

    async updateJobPositionBaseFactorGrade(jobPositionId, baseFactorId, gradeNumber) {
        let formData = new FormData();
        formData.append('jobPositionId', jobPositionId);
        formData.append('BaseFactorId', baseFactorId);
        formData.append('gradeNumber', gradeNumber);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WageSetting/UpdateJobPositionBaseFactorGrade", formData, config);
        var data = response.data;
        return data;
    }

    async deleteBaseFactorGrade(baseFactorId, gradeNumber) {
        if (baseFactorId == null)
            baseFactorId = "";
        if (gradeNumber == null)
            gradeNumber = "";
        const response = await http.get("/WageSetting/DeleteBaseFactorGrade?baseFactorId=" + baseFactorId + "&gradeNumber=" + gradeNumber);
        var data = response.data;
        return data;
    }

    async getJobPostionTasksFromPositionBlock(positionBlockId) {
        if (positionBlockId == null)
            positionBlockId = "";
        const response = await http.get("/WageSetting/getJobPostionTasksFromPositionBlock?positionBlockId=" + positionBlockId);
        var data = response.data;
        return data;
    }

    async getBlockGrades() {
        const response = await http.get("/WageSetting/getBlockGrades");
        var data = response.data;
        return data;
    }

    async getPositionBlockGrade(jobPositionId) {
        if (jobPositionId == null)
            jobPositionId = "";
        const response = await http.get("/WageSetting/getPositionBlockGrade?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async updateJobPositionBlockGrade(positionBlockId,blockGradeId) {
        if (positionBlockId == null)
            positionBlockId = "";
        if (blockGradeId == null)
            blockGradeId = "";
        const response = await http.get("/WageSetting/UpdateJobPositionBlockGrade?positionBlockId=" + positionBlockId + "&blockGradeId=" + blockGradeId);
        var data = response.data;
        return data;
    }

    async addBlockGrade(gradeNumber, from, to, points) {
        if (gradeNumber == null)
            gradeNumber = "";
        if (from == null)
            from = "";
        if (to == null)
            to = "";
        if (points == null)
            points = "";
        const response = await http.get("/WageSetting/addBlockGrade?gradeNumber=" + gradeNumber + "&from=" + from + "&to=" + to + "&points=" + points);
        var data = response.data;
        return data;
    }

    async deleteBlockGrade(blockGradeId) {
        if (blockGradeId == null)
            blockGradeId = "";
        const response = await http.get("/WageSetting/deleteBlockGrade?blockGradeId=" + blockGradeId);
        var data = response.data;
        return data;
    }
     
    async getBlockAnalysis(jobPositionId, referencePosition) {
        if (jobPositionId == null)
            jobPositionId = "";
        if (referencePosition == null)
            referencePosition = "";
        const response = await http.get("/WageSetting/getBlockAnalysis?jobPositionId=" + jobPositionId + "&referencePosition=" + referencePosition);
        var data = response.data;
        return data;
    }

    async getBaseFactors() {
        const response = await http.get("/WageSetting/GetBaseFactors");
        var data = response.data;
        return data;
    }

    async getIndividualFactors(sort) {
        if (sort == null)
            sort = "";
        const response = await http.get("/WageSetting/GetIndividualFactors?sort=" + sort);
        var data = response.data;
        return data;
    }

    async getIDynamicFactors(sort) {
        if (sort == null)
            sort = "";
        const response = await http.get("/WageSetting/GetDynamicFactors?sort=" + sort);
        var data = response.data;
        return data;
    }

    async updateIndividualGrade(individualFactorId, gradeNumber, from, to, description, points) {
        if (individualFactorId == null)
            individualFactorId = "";
        if (gradeNumber == null)
            gradeNumber = "";
        if (from == null)
            from = "";
        if (to == null)
            to = "";
        if (description == null)
            description = "";
        if (points == null)
            points = "";
        const response = await http.get("/WageSetting/updateIndividualGrade?individualFactorId=" + individualFactorId + "&gradeNumber=" + gradeNumber + "&from=" + from + "&to=" + to + "&description=" + description + "&points=" + points);
        var data = response.data;
        return data;
    }

    async updateIndividualFactor(individualFactorId, factorNumber, factorName, calculationType, extent) {
        if (individualFactorId == null)
            individualFactorId = "";
        if (factorNumber == null)
            factorNumber = "";
        if (factorName == null)
            factorName = "";
        if (calculationType == null)
            calculationType = "";
        if (extent == null)
            extent = "";
        const response = await http.get("/WageSetting/UpdateIndividualFactor?individualFactorId=" + individualFactorId + "&factorNumber=" + factorNumber + "&factorName=" + factorName + "&calculationType=" + calculationType + "&extent=" + extent);
        var data = response.data;
        return data;
    }

    async getIndividualGrades(individualFactorId, sort) {
        if (individualFactorId == null)
            individualFactorId = "";
        if (sort == null)
            sort = "";
        const response = await http.get("/WageSetting/GetIndividualGrades?individualFactorId=" + individualFactorId + "&sort=" + sort);
        var data = response.data;
        return data;
    }

    async addIndividualFactor(factorNumber, factorName, calculationType, extent) {
        if (factorNumber == null)
            factorNumber = "";
        if (factorName == null)
            factorName = "";
        if (calculationType == null)
            calculationType = "";
        if (extent == null)
            extent = "";
        const response = await http.get("/WageSetting/AddIndividualFactor?factorNumber=" + factorNumber + "&factorName=" + factorName + "&calculationType=" + calculationType + "&extent=" + extent);
        var data = response.data;
        return data;
    }

    async deleteIndividualFactor(individualFactorId) {
        if (individualFactorId == null)
            individualFactorId = "";
        const response = await http.get("/WageSetting/DeleteIndividualFactor?individualFactorId=" + individualFactorId);
        var data = response.data;
        return data;
    }

    async addIndividualFactorGrade(individualFactorId, gradeNumber, from, to, description, points) {
        if (individualFactorId == null)
            individualFactorId = "";
        if (gradeNumber == null)
            gradeNumber = "";
        if (from == null)
            from = "";
        if (to == null)
            to = "";
        if (description == null)
            description = "";
        if (points == null)
            points = "";
        const response = await http.get("/WageSetting/AddIndividualFactorGrade?individualFactorId=" + individualFactorId + "&gradeNumber=" + gradeNumber + "&from=" + from + "&to=" + to + "&description=" + description + "&points=" + points);
        var data = response.data;
        return data;
    }

    async deleteIndividualFactorGrade(individualFactorGrade, gradeNumber) {
        if (individualFactorGrade == null)
            individualFactorGrade = "";
        if (gradeNumber == null)
            gradeNumber = "";
        const response = await http.get("/WageSetting/DeleteIndividualFactorGrade?individualFactorGrade=" + individualFactorGrade + "&gradeNumber=" + gradeNumber);
        var data = response.data;
        return data;
    }

    async getDynamicFactors() {
        const response = await http.get("/WageSetting/getDynamicFactors");
        var data = response.data;
        return data;
    }

    async getDynamicGrades(dynamicFactorId) {
        if (dynamicFactorId == null)
            dynamicFactorId = "";
        const response = await http.get("/WageSetting/getDynamicGrades?dynamicFactorId=" + dynamicFactorId);
        var data = response.data;
        return data;
    }

    async updateDynamicFactor(dynamicFactorId, factorNumber, factorName, extent) {
        if (dynamicFactorId == null)
            dynamicFactorId = "";
        if (factorNumber == null)
            factorNumber = "";
        if (factorName == null)
            factorName = "";
        if (extent == null)
            extent = "";
        const response = await http.get("/WageSetting/updateDynamicFactor?dynamicFactorId=" + dynamicFactorId + "&factorNumber=" + factorNumber + "&factorName=" + factorName + "&extent=" + extent);
        var data = response.data;
        return data;
    }

    async addDynamicFactor(factorNumber, factorName, extent) {
        if (factorNumber == null)
            factorNumber = "";
        if (factorName == null)
            factorName = "";
        if (extent == null)
            extent = "";
        const response = await http.get("/WageSetting/addDynamicFactor?factorNumber=" + factorNumber + "&factorName=" + factorName + "&extent=" + extent);
        var data = response.data;
        return data;
    }

    async deleteDynamicFactor(dynamicFactorId) {
        if (dynamicFactorId == null)
            dynamicFactorId = "";
        const response = await http.get("/WageSetting/deleteDynamicFactor?dynamicFactorId=" + dynamicFactorId);
        var data = response.data;
        return data;
    }

    async addDynamicFactorGrade(dynamicFactorId, gradeNumber) {
        if (dynamicFactorId == null)
            dynamicFactorId = "";
        if (gradeNumber == null)
            gradeNumber = "";
        const response = await http.get("/WageSetting/addDynamicFactorGrade?dynamicFactorId=" + dynamicFactorId + "&gradeNumber=" + gradeNumber);
        var data = response.data;
        return data;
    }

    async deleteDynamicFactorGrade(dynamicFactorGrade, gradeNumber) {
        if (dynamicFactorGrade == null)
            dynamicFactorGrade = "";
        if (gradeNumber == null)
            gradeNumber = "";
        const response = await http.get("/WageSetting/deleteDynamicFactorGrade?dynamicFactorGrade=" + dynamicFactorGrade + "&gradeNumber=" + gradeNumber);
        var data = response.data;
        return data;
    }

    async getEmployeesFromJobPosition(jobPositionId) {
        if (jobPositionId == null)
            jobPositionId = "";
        const response = await http.get("/WageSetting/GetEmployeesFromJobPosition?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async getEmployeesFromCompany(sort) {
        if (sort == null)
            sort = "";
        const response = await http.get("/WageSetting/GetEmployeesFromCompany?sort=" + sort);
        var data = response.data;
        return data;
    }

    async getEmployeeAnalysisCriteria() {
        const response = await http.get("/WageSetting/GetEmployeeAnalysisCriteria");
        var data = response.data;
        return data;
    }

    async updateEmployeeAnalysisCriteria(analysisCriteria1, analysisCriteria2) {
        let formData = new FormData();
        formData.append('analysisCriteria1', analysisCriteria1);
        formData.append('analysisCriteria2', analysisCriteria2);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WageSetting/updateEmployeeAnalysisCriteria", formData, config);
        var data = response.data;
        return data;
    }


    async addEmployee(employeeNumber,  firstName, lastName, socialSecurityNumber, sex, emploeeStartDate, occupationStartDate, analysisCriteria1, analysisCriteria2, jobPositionId){
        let formData = new FormData();
        formData.append('employeeNumber', employeeNumber);
        formData.append('firstName', firstName);
        formData.append('lastName', lastName);
        formData.append('socialSecurityNumber', socialSecurityNumber);
        formData.append('sex', sex);
        formData.append('emploeeStartDate', emploeeStartDate);
        formData.append('occupationStartDate', occupationStartDate);
        formData.append('emploeeStartDate', emploeeStartDate);
        formData.append('analysisCriteria1', analysisCriteria1);
        formData.append('analysisCriteria2', analysisCriteria2);
        formData.append('jobPositionId', jobPositionId);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WageSetting/AddEmployee", formData, config);
        var data = response.data;
        return data;
    }

    async UpdateEmployee(employeeId, employeeNumber, firstName, lastName, socialSecurityNumber, sex, emploeeStartDate, occupationStartDate, analysisCriteria1, analysisCriteria2, jobPosition) {
        let formData = new FormData();
        formData.append('employeeId', employeeId);
        formData.append('employeeNumber', employeeNumber);
        formData.append('firstName', firstName);
        formData.append('lastName', lastName);
        formData.append('socialSecurityNumber', socialSecurityNumber);
        formData.append('sex', sex);
        formData.append('emploeeStartDate', emploeeStartDate);
        formData.append('occupationStartDate', occupationStartDate);
        formData.append('emploeeStartDate', emploeeStartDate);
        formData.append('analysisCriteria1', analysisCriteria1);
        formData.append('analysisCriteria2', analysisCriteria2);
        formData.append('jobPosition', jobPosition);
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        const response = await http.post("/WageSetting/UpdateEmployee", formData, config);
        var data = response.data;
        return data;
    }

    async deleteEmployee(employeeId) {
        if (employeeId == null)
            employeeId = "";
        const response = await http.get("/WageSetting/deleteEmployee?employeeId=" + employeeId);
        var data = response.data;
        return data;
    }

    async deleteEmployees(employees) {
        const response = await http.post("/WageSetting/deleteEmployees", JSON.stringify(employees));
        var data = response.data;
        return data;
    }

    async setEmployeePosition(employeeId, jobPositionId) {
        if (employeeId == null)
            employeeId = "";
        if (jobPositionId == null)
            jobPositionId = "";
        const response = await http.get("/WageSetting/setEmployeePosition?employeeId=" + employeeId + "&jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async getCompetenciesFromEmployee(employeeId) {
        if (employeeId == null)
            employeeId = "";
        const response = await http.get("/WageSetting/GetCompetenciesFromEmployee?employeeId=" + employeeId);
        var data = response.data;
        return data;
    }

    async updateEmployeeIndividualGrade(employeeId, individualFactorId, scaleValue, scaleText, gradeNumber) {
        if (employeeId == null)
            employeeId = "";
        if (individualFactorId == null)
            individualFactorId = "";
        if (scaleValue == null)
            scaleValue = "";
        if (scaleText == null)
            scaleText = "";
        if (gradeNumber == null)
            gradeNumber = "";
        const response = await http.get("/WageSetting/UpdateEmployeeIndividualGrade?employeeId=" + employeeId + "&individualFactorId=" + individualFactorId + "&scaleValue=" + scaleValue + "&scaleText=" + scaleText + "&gradeNumber=" + gradeNumber);
        var data = response.data;
        return data;
    }

    async updateEmployeeDynamicGrade(employeeId, dynamicFactorId, gradeNumber) {
        if (employeeId == null)
            employeeId = "";
        if (dynamicFactorId == null)
            dynamicFactorId = "";
        if (gradeNumber == null)
            gradeNumber = "";
        const response = await http.get("/WageSetting/updateEmployeeDynamicGrade?employeeId=" + employeeId + "&dynamicFactorId=" + dynamicFactorId + "&gradeNumber=" + gradeNumber);
        var data = response.data;
        return data;
    }

    async getCompetenceMatrixFromJobPosition(jobPositionId) {
        if (jobPositionId == null)
            jobPositionId = "";
        const response = await http.get("/WageSetting/getCompetenceMatrixFromJobPosition?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }

    async updateEmployeeCompetencies(employeeId, employeeCompetencies) {
        if (employeeId == null)
            employeeId = "";
        const response = await http.post("/WageSetting/UpdateEmployeeCompetencies?employeeId=" + employeeId, JSON.stringify(employeeCompetencies));
        var data = response.data;
        return data;
    }

    async getEmployeeIndividualFactors(employeeId) {
        if (employeeId == null)
            employeeId = "";
        const response = await http.get("/WageSetting/GetEmployeeIndividualFactors?employeeId=" + employeeId);
        var data = response.data;
        return data;
    }

    async getEmployeeIndividualFactorPoints(employeeId) {
        if (employeeId == null)
            employeeId = "";
        const response = await http.get("/WageSetting/GetEmployeeIndividualFactorPoints?employeeId=" + employeeId);
        var data = response.data;
        return data;
    }

    async addEmployeeIndividualFactor(employeeId, individualFactorId) {
        if (employeeId == null)
            employeeId = "";
        if (individualFactorId == null)
            individualFactorId = "";
        const response = await http.get("/WageSetting/AddEmployeeIndividualFactor?employeeId=" + employeeId + "&individualFactorId=" + individualFactorId);
        var data = response.data;
        return data;
    }

    async removeEmployeeIndividualFactor(employeeId, individualFactorId) {
        if (employeeId == null)
            employeeId = "";
        if (individualFactorId == null)
            individualFactorId = "";
        const response = await http.get("/WageSetting/RemoveEmployeeIndividualFactor?employeeId=" + employeeId + "&individualFactorId=" + individualFactorId);
        var data = response.data;
        return data;
    }

    async getEmployeeDynamicFactors(employeeId) {
        if (employeeId == null)
            employeeId = "";
        const response = await http.get("/WageSetting/GetEmployeeDynamicFactors?employeeId=" + employeeId);
        var data = response.data;
        return data;
    }

    async getEmployeeDynamicFactorPoints(employeeId) {
        if (employeeId == null)
            employeeId = "";
        const response = await http.get("/WageSetting/GetEmployeeDynamicFactorPoints?employeeId=" + employeeId);
        var data = response.data;
        return data;
    }

    async addEmployeeDynamicFactor(employeeId, individualFactorId) {
        if (employeeId == null)
            employeeId = "";
        if (individualFactorId == null)
            individualFactorId = "";
        const response = await http.get("/WageSetting/addEmployeeDynamicFactor?employeeId=" + employeeId + "&individualFactorId=" + individualFactorId);
        var data = response.data;
        return data;
    }

    async removeEmployeeDynamicFactor(employeeId, individualFactorId) {
        if (employeeId == null)
            employeeId = "";
        if (individualFactorId == null)
            individualFactorId = "";
        const response = await http.get("/WageSetting/RemoveEmployeeDynamicFactor?employeeId=" + employeeId + "&individualFactorId=" + individualFactorId);
        var data = response.data;
        return data;
    }

    async updateBaseSalaries(jobPositionsWithSalary) {
        const response = await http.post("/WageSetting/UpdateBaseSalaries", JSON.stringify(jobPositionsWithSalary));
        var data = response.data;
        return data;
    }

    async updateBaseWagepart(newValueSelected, calculationType, baseSalaryPerPoint) {
        const response = await http.get("/WageSetting/UpdateBaseWagepart?newValueSelected=" + newValueSelected + "&calculationType=" + calculationType + "&baseSalaryPerPoint=" + baseSalaryPerPoint);
        var data = response.data;
        return data;
    }

    async updateBlockWagepart(newValueSelected, calculationType, blockSalary, blockSalaryPerPoint) {
        const response = await http.get("/WageSetting/UpdateBlockWagepart?newValueSelected=" + newValueSelected + "&calculationType=" + calculationType + "&blockSalary=" + blockSalary + "&blockSalaryPerPoint=" + blockSalaryPerPoint);
        var data = response.data;
        return data;
    }

    async updateIndividualWagepart(newValueSelected, calculationType, individualSalary, individualSalaryPerPoint) {
        const response = await http.get("/WageSetting/UpdateIndividualWagepart?newValueSelected=" + newValueSelected + "&calculationType=" + calculationType + "&individualSalary=" + individualSalary + "&individualSalaryPerPoint=" + individualSalaryPerPoint);
        var data = response.data;
        return data;
    }

    async getWagePartBase() {
        const response = await http.get("/WageSetting/GetWagePartBase");
        var data = response.data;
        return data;
    }

    async getWagePartBlock() {
        const response = await http.get("/WageSetting/GetWagePartBlock");
        var data = response.data;
        return data;
    }

    async getWagePartIndividual() {
        const response = await http.get("/WageSetting/GetWagePartIndividual");
        var data = response.data;
        return data;
    }

    async getWagePartDynamic() {
        const response = await http.get("/WageSetting/GetWagePartDynamic");
        var data = response.data;
        return data;
    }

    async deleteSalaryInterval(salaryIntervalId) {
        if (salaryIntervalId == null)
            salaryIntervalId = "";
        const response = await http.get("/WageSetting/deleteSalaryInterval?salaryIntervalId=" + salaryIntervalId);
        var data = response.datasalaryIntervalId
        return data;
    }

    async updateSalaryInterval(salaryIntervalId, from, to, salary) {
        if (salaryIntervalId == null)
            salaryIntervalId = "";
        if (from == null)
            from = "";
        if (to == null)
            to = "";
        if (salary == null)
            salary = "";
        const response = await http.get("/WageSetting/UpdateSalaryInterval?salaryIntervalId=" + salaryIntervalId + "&from=" + from + "&to=" + to + "&salary=" + salary);
        var data = response.datasalaryIntervalId
        return data;
    }

    async getSalaryInterval(type) {
        if (type == null)
            type = "";
        const response = await http.get("/WageSetting/getSalaryInterval?type=" + type);
        var data = response.data;
        return data;
    }

    async getPositionsWithPoints() {
        const response = await http.get("/WageSetting/GetPositionsWithPoints");
        var data = response.data;
        return data;
    }

    /*
    async getPartSalaryType() {
        const response = await http.get("/WageSetting/GetPartSalaryType");
        var data = response.data;
        return data;
    }
    */

    async addSalaryInterval(from, to, salary) {
        if (from == null)
            from = "";
        if (to == null)
            to = "";
        if (salary == null)
            salary = "";
        const response = await http.get("/WageSetting/addSalaryInterval?from=" + from + "&to=" + to + "&salary=" + salary);
        var data = response.data;
        return data;
    }

    async addBlockSalaryInterval(from, to, salary) {
        if (from == null)
            from = "";
        if (to == null)
            to = "";
        if (salary == null)
            salary = "";
        const response = await http.get("/WageSetting/addBlockSalaryInterval?from=" + from + "&to=" + to + "&salary=" + salary);
        var data = response.data;
        return data;
    }

    async updatePositionBlockSalaries(salaries) {
        const response = await http.post("/WageSetting/UpdatePositionBlockSalaries", JSON.stringify(salaries));
        var data = response.data;
        return data;
    }

    async updatePositionBlockPotSalaries(salaries) {
        const response = await http.post("/WageSetting/UpdatePositionBlockPotSalaries", JSON.stringify(salaries));
        var data = response.data;
        return data;
    }

    async updatePositionBlockSalary(salary) {
        const response = await http.post("/WageSetting/UpdatePositionBlockSalary", JSON.stringify(salary));
        var data = response.data;
        return data;
    }

    async updatePositionBlockPotSalary(salary) {
        const response = await http.post("/WageSetting/UpdatePositionBlockPotSalary", JSON.stringify(salary));
        var data = response.data;
        return data;
    }

    async getEmployeeIndividualFactorGrades(extent) {
        const response = await http.get("/WageSetting/GetEmployeeIndividualFactorGrades?extent=" + extent);
        var data = response.data;
        return data;
    }

    async updateEmployeeIndividualFactorPersonAddition(individualFactorAddons) {
        const response = await http.post("/WageSetting/UpdateEmployeeIndividualFactorPersonAddition", JSON.stringify(individualFactorAddons));
        var data = response.data;
        return data;
    }

    async getEmployeeIndividualFactorPersonAddition() {
        const response = await http.get("/WageSetting/GetEmployeeIndividualFactorPersonAddition");
        var data = response.data;
        return data;
    }

    async getDynamicFactorGrades(extent) {
        const response = await http.get("/WageSetting/GetDynamicFactorGrades?extent=" + extent);
        var data = response.data;
        return data;
    }

    /*
    async GetEmployeeIndividualFactorsByPosition(jobPositionId) {
        const response = await http.get("/WageSetting/GetEmployeeIndividualFactorsByPosition?jobPositionId=" + jobPositionId);
        var data = response.data;
        return data;
    }
    */

    async updateEmployeeIndividualFactorGrades(factorGradeValues) {
        const response = await http.post("/WageSetting/UpdateEmployeeIndividualFactorGrades", JSON.stringify(factorGradeValues));
        var data = response.data;
        return data;
    }

    async updateDynamicFactorGrades(factorGradeValues) {
        const response = await http.post("/WageSetting/UpdateDynamicFactorGrades", JSON.stringify(factorGradeValues));
        var data = response.data;
        return data;
    }

    async addIndividualSalaryInterval(from, to, salary) {
        if (from == null)
            from = "";
        if (to == null)
            to = "";
        if (salary == null)
            salary = "";
        const response = await http.get("/WageSetting/addIndividualSalaryInterval?from=" + from + "&to=" + to + "&salary=" + salary);
        var data = response.data;
        return data;
    }

    async getIndividualSalaryIntervals() {
        const response = await http.get("/WageSetting/GetIndividualSalaryIntervals");
        var data = response.data;
        return data;
    }

    async getEmployeesFromVirtualcompany() {
        const response = await http.get("/WageSetting/GetEmployeesFromVirtualcompany");
        var data = response.data;
        return data;
    }

    async getSavedAnalysises() {
        const response = await http.get("/WageSetting/GetSavedAnalysises");
        var data = response.data;
        return data;
    }

    async getMaxWageparts() {
        const response = await http.get("/WageSetting/GetMaxWageparts");
        var data = response.data;
        return data;
    }

    async saveLargeSalaryAnalysis(name) {
        const response = await http.get("/WageSetting/saveLargeSalaryAnalysis?name=" + name);
        var data = response.data;
        return data;
    }

    async getLargeSalaryAnalysisSumSalary(employeeId, positionName, sex) {
        if (employeeId == null)
            employeeId = "";
        if (positionName == null)
            positionName = "";
        if (sex == null)
            sex = "";
        const response = await http.get("/WageSetting/GetLargeSalaryAnalysisSumSalary?employeeId=" + employeeId + "&positionName=" + positionName + "&sex=" + sex);
        var data = response.data;
        return data;
    }

    async getLargeSalaryAnalysis(employeeId, positionName, sex, sortBy) {
        if (employeeId == null)
            employeeId = "";
        if (positionName == null)
            positionName = "";
        if (sex == null)
            sex = "";
        if (sortBy == null)
            sortBy = "";
        const response = await http.get("/WageSetting/GetLargeSalaryAnalysis?employeeId=" + employeeId + "&positionName=" + positionName + "&sex=" + sex + "&sortBy=" + sortBy);
        var data = response.data;
        return data;
    }

    async getLargeSalaryAnalysisDiagram(employeeId, positionName, sex, sortBy) {
        if (employeeId == null)
            employeeId = "";
        if (positionName == null)
            positionName = "";
        if (sex == null)
            sex = "";
        if (sortBy == null)
            sortBy = "";
        const response = await http.get("/WageSetting/GetLargeSalaryAnalysisDiagram?employeeId=" + employeeId + "&positionName=" + positionName + "&sex=" + sex + "&sortBy=" + sortBy);
        var data = response.data;
        return data;
    }

    async getTotalWageOverview() {
        const response = await http.get("/WageSetting/GetTotalWageOverview");
        var data = response.data;
        return data;
    }

    async getSavedAnalyzes() {
        const response = await http.get("/WageSetting/GetSavedAnalyzes");
        var data = response.data;
        return data;
    }
    async deleteSavedAnalysis(documentId) {
        const response = await http.get("/WageSetting/deleteSavedAnalysis?documentId=" + documentId);
        var data = response.data;
        return data;
    }



    // PotDistribution

    async getPotDistribution() {
        const response = await http.get("/WageSetting/GetPotDistribution");
        var data = response.data;
        return data;
    }

    async updatePotSalaries(potsalaries) {
        const response = await http.post("/WageSetting/UpdatePotSalaryIntervals", JSON.stringify(potsalaries));
        var data = response.datasalaryIntervalId
        return data;
    }

    async updatePotSalaryInterval(salaryIntervalId, potsalary) {
        if (salaryIntervalId == null)
            salaryIntervalId = "";
        if (potsalary == null)
            potsalary = "";
        
        const response = await http.get("/WageSetting/UpdatePotSalaryInterval?salaryIntervalId=" + salaryIntervalId + "&potsalary=" + potsalary);
        var data = response.datasalaryIntervalId
        return data;
    }

    async updateEmployeeIndividualPotFactorGrades(factorGradeValues) {
        const response = await http.post("/WageSetting/UpdateEmployeeIndividualPotFactorGrades", JSON.stringify(factorGradeValues));
        var data = response.data;
        return data;
    }
    /*
    async setIndividualPartPotSalary(salaryPerPoint) {
        const response = await http.get("/WageSetting/SetIndividualPartPotSalary?salaryPerPoint=" + salaryPerPoint);
        var data = response.data;
        return data;
    }
    */

    async transferPot() {
        const response = await http.get("/WageSetting/TransferPot");
        var data = response.data;
        return data;
    }

    
    async setIntervalPotSalary(intervalId, potSalary) {
        const response = await http.get("/WageSetting/SetIntervalPotSalary?intervalId=" + intervalId + "&potSalary=" + potSalary);
        var data = response.data;
        return data;
    }

    async setPotSalarySum(potSalarySum, reset) {
        const response = await http.get("/WageSetting/SetPotSalarySum?potSalarySum=" + potSalarySum + "&reset=" + reset);
        var data = response.data;
        return data;
    }

    // kontrollera de h�r..


    async UpdatePotBaseSalaries(jobPositionsWithSalary) {
        const response = await http.post("/WageSetting/UpdatePotBaseSalaries", JSON.stringify(jobPositionsWithSalary));
        var data = response.data;
        return data;
    }

    async UpdatePotBlockSalaries(salaries) {
        const response = await http.post("/WageSetting/UpdatePotBlockSalaries", JSON.stringify(salaries));
        var data = response.data;
        return data;
    }

    async updateBasePotWagepart(newValueSelected, calculationType, basePotSalary, basePotSalaryPerPoint) {
        const response = await http.get("/WageSetting/UpdateBasePotWagepart?newValueSelected=" + newValueSelected + "&calculationType=" + calculationType + "&basePotSalary=" + basePotSalary + "&basePotSalaryPerPoint=" + basePotSalaryPerPoint);
        var data = response.data;
        return data;
    }

    async updateBlockPotWagepart(newValueSelected, calculationType, blockPotSalary, blockPotSalaryPerPoint) {
        const response = await http.get("/WageSetting/UpdateBlockPotWagepart?newValueSelected=" + newValueSelected + "&calculationType=" + calculationType + "&blockPotSalary=" + blockPotSalary + "&blockPotSalaryPerPoint=" + blockPotSalaryPerPoint);
        var data = response.data;
        return data;
    }

    async updateIndividualPotWagepart(newValueSelected, calculationType, individualPotSalary, individualPotSalaryPerPoint) {
        const response = await http.get("/WageSetting/UpdateIndividualPotWagepart?newValueSelected=" + newValueSelected + "&calculationType=" + calculationType + "&individualPotSalary=" + individualPotSalary + "&individualPotSalaryPerPoint=" + individualPotSalaryPerPoint);
        var data = response.data;
        return data;
    }

    async updateDynamicFactors() {
        const response = await http.get("/WageSetting/UpdateDynamicFactors");
        var data = response.data;
        return data;
    }

    async updateIndividualFactors() {
        const response = await http.get("/WageSetting/UpdateIndividualFactors");
        var data = response.data;
        return data;
    }

    async updateCompetenceNeeds(positionsblocksWithNeeds) {
        const response = await http.post("/WageSetting/UpdateCompetenceNeeds", JSON.stringify(positionsblocksWithNeeds));
        var data = response.data;
        return data;
    }

    async updateEmployeeCompetency(employeeId, positionBlockId, val, comment, reminder) {
        if (comment == null)
            comment = "";
        const response = await http.get("/WageSetting/updateEmployeeCompetency?employeeId=" + employeeId + "&positionBlockId=" + positionBlockId + "&val=" + val + "&comment=" + comment + "&reminder=" + reminder);
        var data = response.data;
        return data;
    }

    
    

    // End of PotDistribution
}

export default new WageService();
